import React, { useEffect, useRef } from 'react';
import styles from '../../styles/confirmModal.module.css';

export default function ConfirmModal({ isOpen, title = 'Confirm', message = '', onConfirm, onCancel }) {
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') onCancel();
    }
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // focus the cancel button to avoid accidental destructive action
    setTimeout(() => cancelRef.current && cancelRef.current.focus(), 0);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-desc">
      <div className={styles.dialog}>
        <h3 id="confirm-title" className={styles.title}>{title}</h3>
        <p id="confirm-desc" className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button ref={cancelRef} type="button" className={styles.cancel} onClick={onCancel}>Cancel</button>
          <button type="button" className={styles.confirm} onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}
